import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { BET_BUILDER, TicketTypes } from '@tickets/constants';
import TicketDetailsAction from '@tickets/modules/ticketDetails/components/actions';
import { useTranslation } from '@common/hooks/translation';
import ActionSquare from '@common/components/actionSquare';
import { TicketsContext } from '@tickets/store/context';
import { PopupContext } from '@app/dev/contexts/popup';

import Config from '@app/dev/config/main';
import TicketDetailsSport from './sport';
import TicketDetailsDeposit from './deposit';
import TicketDetailsBetBuilder from './betBuilder';
import TicketDetailsCasino from './casino';

import './style.scss';

const TicketDetailsPopup = ({ data, isDisable, ticketType }) => {
  const t = useTranslation();
  const [tickets, setTickets] = useContext(TicketsContext);
  const ticketData = data ?? tickets[ticketType]?.[0];
  const [cashoutAmount, setCashoutAmount] = useState(null);
  const [{ closePopup }] = useContext(PopupContext);

  const isBetBuilder = ticketData?.dataFromSwarm?.type_name === BET_BUILDER;
  const casinoGameName = ticketData?.dataFromCasino?.BetMultiplyInfo[0]?.GameName;

  const typeComponentMap = {
    [TicketTypes.SPORT]: TicketDetailsSport,
    [TicketTypes.DEPOSIT]: TicketDetailsDeposit,
    [TicketTypes.CASINO]: TicketDetailsCasino,
  };

  const TicketDetailsContent = isBetBuilder
    ? TicketDetailsBetBuilder : typeComponentMap[ticketType];
  const showCasinoIframe = Config.main.casinoIframeGameNames.includes(casinoGameName) && isDisable;

  return (
    <div
      className={classnames('T-popup-container C-ticket-details', {
        'casino-iframe': showCasinoIframe,
      })}
    >
      <span className="T-popup-title">{t('Ticket Details')}</span>

      <TicketDetailsContent ticket={ticketData} showCasinoIframe={showCasinoIframe} />

      {isDisable ? (
        <ActionSquare actionName="Close" icon="icon-regular-close" onClick={() => closePopup()} className="close-btn" />
      ) : (
        ticketData && (
          <TicketDetailsAction
            ticket={ticketData}
            setTickets={setTickets}
            tickets={tickets}
            cashoutAmount={cashoutAmount}
            onCashoutAmountChange={setCashoutAmount}
          />
        )
      )}
    </div>
  );
};

export default TicketDetailsPopup;

TicketDetailsPopup.propTypes = {
  data: PropTypes.object,
  isDisable: PropTypes.bool,
  ticketType: PropTypes.string,
};
